import axios from "axios";
import { getCategoriesList } from "Adapters/ApiAdapter/categories";

export const getCategoriesFilters = () => {
  return getCategoriesList();
};

export const getAoiFilters = () => {
  return axios.get("/api/p/areas-of-interest/list");
};

export const getCreatorsFilters = () => {
  return axios.get("/api/creators/list");
};
